// extracted by mini-css-extract-plugin
export default {"completeText":"M3jlqT"};